import { StepContainer, StepContent, StepForm, StepHeading, StepNavigator, StepToggleButton, StepToggleButtonGroup } from '../../components';
import { MatchingFlowTypeEnum, WhoNextData } from '../types';
import { getModalityFromBookingForEnum } from '../../utils';
import { useModalitiesQuery, useProviderPublicMatchingProfile } from '@uplift/queries';
import { ProviderMedicalRole } from '@uplift/types';
import { BookingForEnum } from '../../types';

export type WhoProps = {
  onNext: (data: WhoNextData) => void;
  onBack: () => void;
  banner: React.ReactNode;
  providerId: string;
  matchingFlow: string;
};

export const Who: React.VFC<WhoProps> = props => {
  const isInviteOrDirectFlow = props.matchingFlow === MatchingFlowTypeEnum.Invite || props.matchingFlow === MatchingFlowTypeEnum.Direct;
  const { data: matchingProfile, isInitialLoading: matchingProfileLoading } = useProviderPublicMatchingProfile(props.providerId, { enabled: isInviteOrDirectFlow && !!props.providerId });
  const { data: modalities = [], isInitialLoading: modalitiesLoading } = useModalitiesQuery();
  const isLoading = matchingProfileLoading || modalitiesLoading;

  const getModalityId = (who: BookingForEnum) => {
    const modalityEnum = getModalityFromBookingForEnum(who);

    return modalities.find(modality => modality.modality === modalityEnum)?.id;
  };

  const onChange = (who: BookingForEnum) => {
    const modalityId = getModalityId(who);

    if (!modalityId) {
      return;
    }

    props.onNext({ who, modalityId: modalityId });
  };

  const hideGroupOptions = isInviteOrDirectFlow && matchingProfile?.user?.medicalRole === ProviderMedicalRole.psychiatrist;

  return (
    <StepContainer>
      {props.banner}
      <StepContent>
        <StepHeading>Who are you booking for?</StepHeading>
        <StepForm maxWidth="343px">
          <StepToggleButtonGroup onChange={(_, who: BookingForEnum) => onChange(who)}>
            <StepToggleButton value={BookingForEnum.Myself} disabled={isLoading}>Myself</StepToggleButton>
            <StepToggleButton value={BookingForEnum.SomeoneElse} disabled={isLoading}>Someone else</StepToggleButton>
            {!hideGroupOptions && <StepToggleButton value={BookingForEnum.MyselfAndPartner} disabled={isLoading}>Myself and my partner</StepToggleButton>}
            {!hideGroupOptions && <StepToggleButton value={BookingForEnum.MyselfAndFamily} disabled={isLoading}>Myself and my family member(s)</StepToggleButton>}
          </StepToggleButtonGroup>
        </StepForm>
      </StepContent>
      <StepNavigator onBack={props.onBack} desktopOnly />
    </StepContainer>
  );
};
